import { unreachable } from '@lfg/core/lib';
import { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

import { APP_ENV } from 'src/global/config/common.config';
import { store } from 'src/store';

import apiClient from './index';

const logOnDev = (message: string, log?: AxiosResponse | InternalAxiosRequestConfig | AxiosError) => {
  if (APP_ENV === 'development') {
    console.log(message, log);
  }
};

apiClient.interceptors.request.use(async request => {
  const { method, url } = request;
  logOnDev(`🚀 [${method?.toUpperCase()}] ${url} | Request`, request);
  if (!store) return unreachable();
  const networkInfo = store.getState().app.networkInfo;

  if (networkInfo) {
    request.headers['x-offchain-network'] = networkInfo.id;
  }

  return request;
});

apiClient.interceptors.response.use(
  response => {
    const { method, url } = response.config;
    const { status } = response || {};

    logOnDev(`✨ [${method?.toUpperCase()}] ${url} | Response ${status}`, response);

    return response;
  },
  async error => {
    const { message } = error;
    const { status, data } = error.response || {};
    const { method, url } = error.config || {};

    logOnDev(`🚨 [${method?.toUpperCase()}] ${url} | Error ${status} ${data?.message || ''} | ${message}`, error);

    return Promise.reject(error);
  },
);
